import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, RouteProps, RouteComponentProps } from 'react-router-dom';
import Footer from './Footer';
import { AppStore, Store } from './types';
import Menu from './Menu';
import NotDispatchedOrders from './NotDispatchedOrders';
import TableEvents from './TableEvents';
import { OPEN_ORDER_PATH, TABLES, TITLES } from './Constants';
import TableOrder from './TableOrder';
import { fetchData } from './actions/Actions';
import { getTokenFromCookies } from './helpers';

interface DispatchProps {
    onFetchData: () => Promise<unknown>;
}

interface StateProps {
    openOrders: AppStore['openOrders'];
    notDispatchedOrders: AppStore['notDispatchedOrders'];
    products: AppStore['products'];
    tables: AppStore['tables'];
    user: AppStore['user'];
    tableEvents: AppStore['tableEvents'];
    workingHours: AppStore['workingHours'];
}

interface OwnProps extends RouteProps {
    component: React.ComponentType<RouteComponentProps>;
}

const Body: React.FC<
    StateProps & DispatchProps & OwnProps & RouteComponentProps<unknown>
> = ({
    // eslint-disable-next-line destructuring/no-rename
    component: Component,
    onFetchData,
    match,
    openOrders,
    notDispatchedOrders,
    products,
    tables,
    user,
    tableEvents,
    workingHours,
    ...rest
}) => {
    React.useEffect(() => {
        onFetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (
        !openOrders ||
        !notDispatchedOrders ||
        !products ||
        !tables ||
        !user ||
        !tableEvents ||
        !workingHours
    ) {
        return null;
    }

    return (
        <Route
            {...rest}
            // eslint-disable-next-line react/jsx-no-bind
            render={props => (
                <div className='body'>
                    <div className='main'>
                        <div className='title'>{TITLES[match.url]}</div>
                        <div className='main-body'>
                            <Menu />
                            <Component {...props} />
                        </div>
                        <div className='footer'>
                            {match.url === OPEN_ORDER_PATH ? (
                                <NotDispatchedOrders />
                            ) : null}
                            <Footer />
                        </div>
                    </div>
                    {match.url === OPEN_ORDER_PATH ? <TableEvents /> : null}
                    {match.url === TABLES ? <TableOrder /> : null}
                </div>
            )}
        />
    );
};

const BodyComp = connect(
    (state: Store): StateProps => ({
        notDispatchedOrders: state.app.notDispatchedOrders,
        openOrders: state.app.openOrders,
        products: state.app.products,
        tableEvents: state.app.tableEvents,
        tables: state.app.tables,
        user: state.app.user,
        workingHours: state.app.workingHours
    }),
    (dispatch): DispatchProps => ({
        onFetchData: () => dispatch<any>(fetchData())
    })
)(Body);

const AuthorizedRoute: React.FC<OwnProps> = ({
    // eslint-disable-next-line destructuring/no-rename
    component: Component,
    ...rest
}) => (
    <Route
        {...rest}
        // eslint-disable-next-line react/jsx-no-bind
        render={props =>
            getTokenFromCookies() ? (
                <BodyComp {...props} component={Component} />
            ) : (
                <Redirect to='/error' />
            )
        }
    />
);

export default AuthorizedRoute;
